import { AuthService } from "./../../services/auth.service";
import { Component, EventEmitter, Output, Inject, OnInit, OnDestroy, ViewChild, AfterViewInit } from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { UserLoginResponse } from "../../models/rest/user/userLoginResponse";
import { RoleCodeEnum } from "../../enum/role-code.enum";
import { NavigationService } from "../../services/navigation.service";
import { DownloadService } from "../../services/core/download.service";
import { DeviceTypeEnum } from "../../enum/type/device-type.enum";
import { PrinterService } from "../../services/core/printer.service";
import { AlertifyService } from "../../services/core/alertify.service";
import { TranslateService } from "@ngx-translate/core";
import { ModalSizeEnum } from "../../enum/modal-size.enum";
import { NgbModal, NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { HelpVideoModalComponent } from "../../core/help-video-modal/help-video-modal.component";
import { LockScreenComponent } from "../../pages/core/lock-screen/lock-screen.component";
import { CashRegisterQuickAccessComponent } from "../../pages/cash-register/cash-register-quick-access/cash-register-quick-access.component";
import { CalleridHistoryReportModalComponent } from "../../pages/voip/callerid-history-report-modal/callerid-history-report-modal.component";
import { SmsLogReportModalComponent } from "../../pages/sms/sms-log-report-modal/sms-log-report-modal.component";
import { DeviceSettingModalComponent } from "../../pages/device/device-setting-modal/device-setting-modal.component";
import { DeviceLocalStorageData } from "../../models/rest/user/device-local-storage-data.model";
import { YesNoModalComponent } from "../../core/yes-no-modal/yes-no-modal.component";
import { YesNoModalTypeEnum } from "../../enum/type/yes_no_modal_type.enum";
import { environment } from "../../../environments/environment";
import { StorageConstants } from "../../constant/storage.constant";
import { SessionStorageService } from "../../services/session-storage.service";
import { ReminderOperationalService } from "../../services/reminder/reminder-operational.service";
import { DateFormatEnum } from "../../enum/date-format.enum";
import { ReminderViewModalComponent } from "../../pages/core/reminder-view-modal/reminder-view-modal.component";
import { GeneralUtils } from '../../utils/general.utils';
import { firstValueFrom, Subscription } from "rxjs";
import { UserOperationalService } from "../../services/user-operational.service";
import { ModalUtilsService } from "../../services/core/modal-utils.service";
import { AppVersionResponse } from "../../models/rest/app/app-version-response";
import { NavigationStart, Router } from "@angular/router";
import { DateUtils } from "../../utils/date.utils";
import { RouteEnum } from "../../enum/route.enum";
import { CustomerScreenService } from "../../services/order/customer-screen.service";
import { WebImageUrlService } from "../../services/app/web-image-url.service";
import { WebImageUrlCategoryTypeEnum } from "../../enum/type/web-image-url-category-type.enum";
import { WebImageUrlSearchRequest } from "../../models/rest/web-image-url/web-image-url-search-request";
declare var $: any;

interface FsDocument extends HTMLDocument {
  webkitFullscreenElement: Element;
  webkitExitFullscreen: any;
  mozFullScreenElement?: Element;
  msFullscreenElement?: Element;
  msExitFullscreen?: () => void;
  mozCancelFullScreen?: () => void;
}

export function isFullScreen(): boolean {
  const fsDoc = <FsDocument>document;

  return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
}

interface FsDocumentElement extends HTMLElement {
  webkitRequestFullscreen: any;
  msRequestFullscreen?: () => void;
  mozRequestFullScreen?: () => void;
}

export function toggleFullScreen(): void {
  const fsDoc = <FsDocument>document;

  if (!isFullScreen()) {
    const fsDocElem = <FsDocumentElement>document.documentElement;

    if (fsDocElem.requestFullscreen)
      fsDocElem.requestFullscreen();
    else if (fsDocElem.msRequestFullscreen)
      fsDocElem.msRequestFullscreen();
    else if (fsDocElem.mozRequestFullScreen)
      fsDocElem.mozRequestFullScreen();
    else if (fsDocElem.webkitRequestFullscreen)
      fsDocElem.webkitRequestFullscreen();
  }
  else if (fsDoc.exitFullscreen)
    fsDoc.exitFullscreen();
  else if (fsDoc.msExitFullscreen)
    fsDoc.msExitFullscreen();
  else if (fsDoc.mozCancelFullScreen)
    fsDoc.mozCancelFullScreen();
  else if (fsDoc.webkitExitFullscreen)
    fsDoc.webkitExitFullscreen();
}

export function setFullScreen(full: boolean): void {
  if (full !== isFullScreen())
    toggleFullScreen();
}


@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();
  @ViewChild('favoritesPopover') favoritesPopover!: NgbPopover;
  @ViewChild('reminderPopover') reminderPopover!: NgbPopover;

  private routerSubscription!: Subscription;
  public config: PerfectScrollbarConfigInterface = {};

  currentUser: UserLoginResponse;
  roleCodeEnum = RoleCodeEnum;
  deviceTypeEnum = DeviceTypeEnum;
  favoriteMenus: any[] = [];
  isFavoritesPopoverOpen = false;
  isReminderPopoverOpen = false;
  deviceLocalStorageData: DeviceLocalStorageData;
  version;
  dateFormatEnum = DateFormatEnum;
  localAppVersion?: AppVersionResponse;

  reminderOpenModalSubscription: Subscription;

  constructor(
    public downloadService: DownloadService,
    private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal,
    private navigation: NavigationService,
    private authService: AuthService,
    private printerService: PrinterService,
    private alertifyService: AlertifyService,
    private translate: TranslateService,
    private sessionStorageService: SessionStorageService,
    public reminderOperationalService: ReminderOperationalService,
    private userOperationalService: UserOperationalService,
    private modalUtilsService: ModalUtilsService,
    private webImageUrlService: WebImageUrlService,
    private router: Router,
    private customerScreenService: CustomerScreenService,
  ) {
    this.authService.currentUser.subscribe(async (res) => {
      const previousUser = this.currentUser;
      this.currentUser = res;

      if (this.currentUser) {
        // Favori menüleri yükle
        this.loadFavorites();

        this.reminderOperationalService.startReminderTimer();
        this.reminderOpenModalSubscription = this.reminderOperationalService.onReminderNotifyModalChanged()
          .subscribe((res) => {
            if (res)
              this.openReminderModal(res);
          });

        await this.checkAndUpdateCustomerScreen(previousUser);
      }
      else {
        this.reminderOperationalService.stopReminderTimer();
      }
    });
  }

  ngOnInit(): void {
    // Router olaylarını dinleyerek offcanvas'ı kapatma
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Offcanvas kapatılıyor
        this.offcanvasService.dismiss();
      }
    });
    this.version = environment.VERSION;
    this.deviceLocalStorageData = this.sessionStorageService.getDeviceStorageData();
  }

  ngAfterViewInit(): void {

    // Popover event'lerini dinle
    if (this.favoritesPopover) {
      this.favoritesPopover.shown.subscribe(() => { this.isFavoritesPopoverOpen = true; });
      this.favoritesPopover.hidden.subscribe(() => { this.isFavoritesPopoverOpen = false; });
    }
    if (this.reminderPopover) {
      this.reminderPopover.shown.subscribe(() => { this.isReminderPopoverOpen = true; });
      this.reminderPopover.hidden.subscribe(() => { this.isReminderPopoverOpen = false; });
    }
  }

  ngOnDestroy(): void {
    // Bellek sızıntılarını önlemek için aboneyi temizleyin
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  async getLocalAppVersion() {
    try {

      const res = await firstValueFrom(this.printerService.getAppVersion());

      this.localAppVersion = res
    }
    catch (err) {
      // this.alertifyService.error(err);
    }
  }

  // Favori Menüler Metodları
  toggleFavoritesPopover() {
    if (!this.favoritesPopover) return;
    if (this.isFavoritesPopoverOpen) {
      this.favoritesPopover.close();
    } else {
      if (this.favoriteMenus.length === 0) this.loadFavorites();
      this.favoritesPopover.open();
    }
  }

  toggleReminderPopover() {
    if (!this.reminderPopover) return;
    if (this.isReminderPopoverOpen) {
      this.reminderPopover.close();
    } else {
      this.reminderPopover.open();
    }
  }

  closeReminderPopover() {
    if (this.reminderPopover) this.reminderPopover.close();
  }

  loadFavorites() {
    console.log('Loading favorites...');

    // MENU_MY_FAVORITE role code'una sahip ana menünün altındaki menüleri yükle
    if (this.currentUser?.menuList) {
      console.log('Current user menu list:', this.currentUser.menuList);

      const favoriteMainMenu = this.currentUser.menuList.find(menu =>
        menu.roleCode === 'MENU_MY_FAVORITE'
      );

      console.log('Found favorite main menu:', favoriteMainMenu);

      if (favoriteMainMenu && favoriteMainMenu.items && favoriteMainMenu.items.length > 0) {
        this.favoriteMenus = favoriteMainMenu.items.map(item => ({
          translateKey: item.translateKey || '',
          routerLink: item.routerLink || '',
          icon: item.icon || 'fas fa-link'
        }));

        console.log('Loaded favorite menus:', this.favoriteMenus);
      } else {
        this.favoriteMenus = [];
        console.log('No favorite menus found');
      }
    } else {
      this.favoriteMenus = [];
      console.log('No current user menu list');
    }
  }

  navigateToFavorite(menu: any) {
    if (menu.routerLink) {
      this.router.navigate([menu.routerLink]);
      this.isFavoritesPopoverOpen = false;
    }
  }

  openReminderModal(data) {
    if (this.reminderOperationalService.isReminderModalOpen || !this.authService.isLoggedIn) {
      // Modal zaten açık, yeni bir modal açmayı engelle
      return;
    }

    this.reminderOperationalService.updateModalStatus(true);
    const modalRef = this.modalService.open(ReminderViewModalComponent, {
      backdrop: true, centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM
    });

    //modal  veri geçişi
    modalRef.componentInstance.data = GeneralUtils.clone(data);
    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry) {
      }

      // modal kapat
      modalRef.close();

    });
    modalRef.result.then(
      (success) => {
        this.reminderOperationalService.updateModalStatus(false);
      },
      (cancel) => {
        this.reminderOperationalService.updateModalStatus(false);
      }
    );

  }

  async openPrinterSetting() {
    const result = await this.modalUtilsService.openPrinterSettingModal();
    if (!result)
      return;
  }
  // This is for Notifications
  notifications: Object[] = [
    {
      round: "round-danger",
      icon: "ti-link",
      title: "Luanch Admin",
      subject: "Just see the my new admin!",
      time: "9:30 AM",
    },
    {
      round: "round-success",
      icon: "ti-calendar",
      title: "Event today",
      subject: "Just a reminder that you have event",
      time: "9:10 AM",
    },
    {
      round: "round-info",
      icon: "ti-settings",
      title: "Settings",
      subject: "You can customize this template as you want",
      time: "9:08 AM",
    },
    {
      round: "round-primary",
      icon: "ti-user",
      title: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM",
    },
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: "assets/images/users/1.jpg",
      status: "online",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:30 AM",
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "busy",
      from: "Sonu Nigam",
      subject: "I have sung a song! See you at",
      time: "9:10 AM",
    },
    {
      useravatar: "assets/images/users/2.jpg",
      status: "away",
      from: "Arijit Sinh",
      subject: "I am a singer!",
      time: "9:08 AM",
    },
    {
      useravatar: "assets/images/users/4.jpg",
      status: "offline",
      from: "Pavan kumar",
      subject: "Just see the my admin!",
      time: "9:00 AM",
    },
  ];


  logout() {

    const modalRef = this.modalService.open(YesNoModalComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM, keyboard: true
    });
    modalRef.componentInstance.modalType = YesNoModalTypeEnum.WARNING;
    modalRef.componentInstance.title = this.translate.instant('title.confirmation');
    modalRef.componentInstance.message = this.translate.instant('confirmation.exit-app');
    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {

      // modal kapat
      modalRef.close();

      // Cevap boş değilse
      if (receivedEntry) {
        this.offcanvasService.dismiss();
        this.authService.doLogout();
      }
    });

  }
  // Favori Menü Fonksiyonalitesi
  changeScreenSize() {
    toggleFullScreen();
  }

  goBack() {
    this.navigation.back();
  }

  checkPrinterStatus() {
    this.printerService.getPrinterServiceIsAlive().subscribe(
      (res) => {
        this.alertifyService.success(this.translate.instant('message.info.printer-service-is-active'));

      },
      (err) => {

        this.alertifyService.error(this.translate.instant('message.error.printer-service-is-not-active'));
      }
    )

  }


  openHelpVideoModal() {
    const modalRef = this.modalService.open(HelpVideoModalComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.XLARGE
    });

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      // Cevap boş değilse
      if (receivedEntry) {


      }

      // modal kapat
      modalRef.close();
    });
  }

  openCashDrawer() {
    this.printerService.openCashRegister(this.sessionStorageService.getString(StorageConstants.PRINTER_RECEIPT) ?? "");
  }
  openPin() {
    if (!this.currentUser) {
      return;
    }
    const modalRef = this.modalService.open(LockScreenComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM, keyboard: false
    });

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {

      // modal kapat
      modalRef.close();

      // Cevap boş değilse
      // if (receivedEntry) {
      // }
      // else {
      //   this.authService.doLogout();
      // }

    });
  }

  lockScreen() {
    this.authService.lockScreen(); const modalRef = this.modalService.open(LockScreenComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.MEDIUM, keyboard: false
    });

    //modal cevap döndüğünde
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {

      // modal kapat
      modalRef.close();
      // this.reset();

      // Cevap boş değilse
      if (receivedEntry) {
        this.authService.unlockScreen();
      }
      else {
        this.authService.doLogout();
      }

    });
  }

  reloadApp() {
    window.location.reload();
  }

  // Bildirim türüne göre ikon sınıfını döndüren bir metod
  getNotificationIconClass(notificationType: string): string {
    switch (notificationType) {
      case 'REMINDER': return 'fa-clock-o'; // REMINDER için saat ikonu
      case 'OPERATIONAL_DEMAND': return 'fa-cogs'; // OPERATIONAL_DEMAND için dişli ikonu
      case 'ORDER': return 'fa-shopping-cart'; // ORDER için alışveriş sepeti ikonu
      default: return 'fa-bell'; // Varsayılan ikon
    }
  }
  getNotificationClass(notificationDate: Date): string {
    const currentDate = DateUtils.getNow();
    const oneHourLater = new Date(currentDate.getTime() + (60 * 60 * 1000)); // Şu andan 1 saat sonrası

    if (notificationDate < currentDate) {
      return 'past-notification'; // Geçmiş zaman için
    } else if (notificationDate < oneHourLater) {
      return 'soon-notification'; // 1 saat içinde olacaklar için
    } else {
      return ''; // Diğer durumlar için
    }
  }
  openUserProfile(content) {

    if (this.localAppVersion == null) {
      this.getLocalAppVersion();
    }
    this.offcanvasService.open(content, {
      ariaLabelledBy: 'offcanvas-basic-title',
      position: 'end' // Sağ tarafta açılması için
    }).result.then((result) => {
      if (result == "Save click") {
      }
    }, (reason) => {
    });
  }

  async saveUserSessionStorage() {
    try {

      await this.userOperationalService.setLocalStorageToDatabase();
      this.alertifyService.success(this.translate.instant("message.info.saved"));
    }
    catch (err) {
      this.alertifyService.error(err);

    }
  }

  downloadAktifMusteri() {
    this.downloadService.downloadAktifMusteri();
  }

  private async checkAndUpdateCustomerScreen(previousUser: UserLoginResponse | null | undefined): Promise<void> {
    this.deviceLocalStorageData = this.sessionStorageService.getDeviceStorageData();

    if (!this.deviceLocalStorageData?.hasCustomerScreen) {
      return;
    }

    if (previousUser && (previousUser.storeId !== this.currentUser.storeId || previousUser.id !== this.currentUser.id)) {
      await this.updateCustomerScreenMeta();
    } else if (!previousUser && this.currentUser) {
      await this.updateCustomerScreenMeta();
    }
  }

  private async updateCustomerScreenMeta(): Promise<void> {
    const storeId = this.authService.getStoreId();

    try {
      const request: WebImageUrlSearchRequest = {
        storeId: storeId,
        categoryType: WebImageUrlCategoryTypeEnum.DISPLAY_SLIDER,
        showActiveRecord: true,
        languageCode: 'all'
      };

      const images = await firstValueFrom(this.webImageUrlService.searchWebImageUrls(request));

      const sliderImages = images
        .filter(img => img.imageUrl)
        .map(img => ({
          title: img.title,
          description: img.description,
          imageUrl: img.imageUrl,
          showOnlyImage: img.showOnlyImage ?? false,
          screenOrderNo: img.screenOrderNo
        }));

      const meta = {
        storeName: this.currentUser?.storeName,
        screenName: this.currentUser?.screenName,
        sliderImages: sliderImages
      };

      this.customerScreenService.setMeta(meta);
    } catch (err) {
      const meta = {
        storeName: this.currentUser?.storeName,
        screenName: this.currentUser?.screenName,
        sliderImages: []
      };

      this.customerScreenService.setMeta(meta);
    }
  }

  async openCustomerScreen() {
    await this.updateCustomerScreenMeta();

    const url = `${window.location.origin}/#${RouteEnum.CUSTOMER_SCREEN}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  openCashRegisterQuickAccess() {
    this.modalService.open(CashRegisterQuickAccessComponent, {
      backdrop: "static",
      centered: true,
      scrollable: false,
      size: ModalSizeEnum.LARGE
    });
  }

  openCalleridHistoryReportModal() {
    this.modalService.open(CalleridHistoryReportModalComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      size: ModalSizeEnum.XXLARGE
    });
  }

  openSmsLogReportModal() {
    this.modalService.open(SmsLogReportModalComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      size: ModalSizeEnum.XXLARGE
    });
  }

  openDeviceSettingModal() {
    this.modalService.open(DeviceSettingModalComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      size: ModalSizeEnum.XLARGE
    });
  }

}
